import { addNestingAndSubfolders, splitFoldersList } from 'newJs/utils/folderList';
import { useQuery } from 'react-query';

import { STORAGE_KEY_NAMES } from 'newJs/config';

const { FOLDERS_LIST } = STORAGE_KEY_NAMES;

const getMSec = () => new Date().getTime();

const fetchData = (storage) => ({
    local: async () => {
        // console.log('fetch local');
        const storageData = storage.get(FOLDERS_LIST);
        return storageData
            ? JSON.parse(storageData)
            : null;
    },
    remote: async ({ fetch, v2 }, disableCache) => {
        // console.log('fetch remote');
        const response = await fetch({ url: v2.getFoldersList(disableCache)});
        const extended = addNestingAndSubfolders(response);
        const result = splitFoldersList(extended);
        storage.set(
            FOLDERS_LIST,
            JSON.stringify({
                savedTimeSec: getMSec(),
                data: result,
            })
        );

        return result;
    }
});

const getData = async (params) => {
    // console.log(params);
    const { MAPI, mapiParams = {}, dataStorage } = params;
    const { fileListCacheTtl: cacheTtl } = mapiParams;
    let { disableCache } = mapiParams;
    const fetch = fetchData(dataStorage);

    const url = new URL(window.location.href);
    disableCache = disableCache !== undefined ? disableCache : !!url.searchParams.get('nocache');

    if (
        Object.entries(mapiParams).length < 1
        || disableCache // If GET param is set
        || cacheTtl < 1
    ) {
        return await fetch.remote(MAPI, true);
    }

    // When local cache enabled
    if (cacheTtl && cacheTtl > 0) {
        const result = await fetch.local(dataStorage);

        if (result) {
            const { data, savedTimeSec } = result;
            const currTimeSec = getMSec();

            return (currTimeSec - savedTimeSec) < cacheTtl
                ? data
                : await fetch.remote(MAPI, true);
        }

        return await fetch.remote(MAPI, true);
    }
};

export default (params) => {
    // console.log(params);
    const { data, status } = useQuery(
        'filesList',
        () => getData(params)
    );

    return { data, status };
};
